import React from 'react';
import { CO2Results } from '../types/carComparison';

interface CO2SummaryCardProps {
  co2Results: CO2Results;
  scenarioName?: string;
  formatCurrency: (value: number) => string;
  comparisonMode?: boolean;
}

const CO2SummaryCard: React.FC<CO2SummaryCardProps> = ({
  co2Results,
  scenarioName = 'Car A',
  formatCurrency,
  comparisonMode = false
}) => {
  return (
    <div className={`summary-card ${comparisonMode ? 'comparison-mode' : ''}`} style={{ border: '2px solid #22c55e' }}>
      <div className="summary-card-header">
        <h3>🌍 CO₂ Emissions - {scenarioName}</h3>
      </div>

      <div className="summary-metrics">
        <div className="metric">
          <span className="metric-label">Total Lifetime Emissions</span>
          <span className="metric-value primary">
            {co2Results.tonnesCO2.toFixed(2)} tonnes CO₂
          </span>
        </div>

        <div className="metric">
          <span className="metric-label">Manufacturing Emissions</span>
          <span className="metric-value">
            {(co2Results.manufacturingEmissions / 1000).toFixed(2)} tonnes
          </span>
        </div>

        <div className="metric">
          <span className="metric-label">Operational Emissions</span>
          <span className="metric-value">
            {(co2Results.operationalEmissions / 1000).toFixed(2)} tonnes
          </span>
        </div>

        <div className="metric">
          <span className="metric-label">
            Environmental Cost (SCC)
            <span style={{
              marginLeft: '0.5rem',
              cursor: 'help',
              fontSize: '0.9rem',
              color: '#666'
            }} title="Based on the Social Cost of Carbon (SCC) — a government estimate of the cost per tonne of CO₂">
              ℹ️
            </span>
          </span>
          <span className="metric-value success">
            {formatCurrency(co2Results.dollarValue)}
          </span>
        </div>
      </div>

      <div style={{
        marginTop: '1rem',
        padding: '0.75rem',
        background: '#f0fdf4',
        borderRadius: '8px',
        fontSize: '0.85rem',
        color: '#666'
      }}>
        <strong>Social Cost of Carbon (SCC):</strong> Based on the Social Cost of Carbon (SCC) — a government estimate of the cost per tonne of CO₂. This represents the economic estimate of environmental damage from CO₂ emissions.
      </div>
    </div>
  );
};

export default CO2SummaryCard;
